import Portfolio8 from './Portfolio8'
export default Portfolio8
